import type { AppVueRouter } from '@modules/core/services/router/types';
import {
  AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_PERMISSIONS,
  AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_ROUTE_NAME,
} from '@modules/affiliate-program-subaffiliate-deals/constants';
import { AppModule } from '@modules/core/plugins/AppModule';

import { AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_EDIT_ROUTE_NAME } from './constants';

export class AffiliateProgramSubAffiliateDealsEditModule extends AppModule {
  addRoutes(router: AppVueRouter): void {
    router.addChildRoute(AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_ROUTE_NAME, {
      name: AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_EDIT_ROUTE_NAME,
      path: 'settings/:id?',
      permission: AFFILIATE_PROGRAM_SUB_AFFILIATE_DEALS_PERMISSIONS.EDIT,

      component: () => import('./pages/AffiliateProgramSubAffiliateDealsEditPage/AffiliateProgramSubAffiliateDealsEditPage.vue'),
    });
  }

  addMenu(): void {}

  addTranslationKeys(): void {}
}
